import { Action, createReducer, on } from '@ngrx/store';
import * as ModifyTypeWizardActions from './actions';
import { State, initialState } from './state';

export const modifyTypeWizardFeatureKey = 'modifyTypeWizard';

const modifyTypeWizardReducer = createReducer(
  initialState,

  on(ModifyTypeWizardActions.selectEntites, (state, { bulkSearchStep }) => ({
    ...state,
    bulkSearchStep,
  })),
  on(ModifyTypeWizardActions.exitModifyTypeWizard, (state) => ({
    ...state,
    bulkSearchStep: null,
    errorMessage: null,
    request: null,
    response: null,
  })),
  on(ModifyTypeWizardActions.destroyWizard, (state) => ({
    ...state,
    bulkSearchStep: null,
    errorMessage: null,
    request: null,
    response: null,
  })),
  on(ModifyTypeWizardActions.createNewModifyType, (state, { request }) => ({
    ...state,
    request,
  })),
  on(ModifyTypeWizardActions.createNewModifyTypeSuccess, (state, { response }) => ({
    ...state,
    response,
  })),
  on(ModifyTypeWizardActions.createNewModifyTypeFail, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return modifyTypeWizardReducer(state, action);
}
